// @flow

import { LogsActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    log: {},
    listaLogs: [],
    distinctUsers: [],
    loading: false,
    error: false,
    formSubmited: false
};

type LogsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { log?: {} | null, listaLogs?: [] | null, distinctUsers?: [] | null, loading?: boolean, +value ?: boolean };

const Logs = (state: State = INIT_STATE, action: LogsAction): any => {
    // console.log(action);
    switch (action.type) {
        case LogsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case LogsActionTypes.GET_LOG: {
                    return {
                        ...state,
                        log: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case LogsActionTypes.LIST_LOGS: {
                    return {
                        ...state,
                        listaLogs: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case LogsActionTypes.ADD_LOG: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case LogsActionTypes.UPDATE_LOG: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case LogsActionTypes.DELETE_LOG: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case LogsActionTypes.DISTINCT_USERS: {
                    return {
                        ...state,
                        distinctUsers: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                default:
                    return { ...state };
            }

        case LogsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case LogsActionTypes.GET_LOG: {
                    return {
                        ...state,
                        error: action.payload.error,
                        log: {},
                        loading: false,
                    };
                }
                case LogsActionTypes.LIST_LOGS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaLogs: [],
                        loading: false,
                    };
                }
                case LogsActionTypes.ADD_LOG: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case LogsActionTypes.UPDATE_LOG: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case LogsActionTypes.DELETE_LOG: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case LogsActionTypes.DISTINCT_USERS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        distinctUsers: [],
                        loading: false,
                    };
                }
                default:
                    return { ...state };
            }

        case LogsActionTypes.GET_LOG:
            return { ...state, error: false, loading: true };
        case LogsActionTypes.LIST_LOGS:
            return { ...state, error: false, loading: true };
        case LogsActionTypes.ADD_LOG:
            return { ...state, error: false, loading: true };
        case LogsActionTypes.UPDATE_LOG:
            return { ...state, error: false, loading: true };
        case LogsActionTypes.DELETE_LOG:
            return { ...state, error: false, loading: true };
        case LogsActionTypes.DISTINCT_USERS:
            return { ...state, error: false, loading: true };
        case LogsActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                log: {},
                listaLogs: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Logs;
